<template>
  <div class="table_wrap">
    <div class="total_length">총 {{ this.paginationData.total }}건</div>
    <el-table class="list-table" header-cell-class-name="list-header" style="width: 100%;" height="695" empty-text="데이터가 없습니다." :data="utilityData">
      <el-table-column label="No" type="index" :index="tableIdx" minWidth="80" width="80" class-name="num text-center"></el-table-column>
      <el-table-column label="소유자 아이디" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.owner_id }}
        </template>
      </el-table-column>
      <el-table-column label="소유자 닉네임" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.owner_nick }}
        </template>
      </el-table-column>
      <el-table-column label="연결된 아이템" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.i_name }}
        </template>
      </el-table-column>
      <el-table-column label="사용현황" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.uu_use_cnt }} / {{ row.u_use_total }}
        </template>
      </el-table-column>
      <el-table-column label="옵션" class-name="text-center">
        <template v-slot="{ row }">
          <el-button class="com_btn" @click="moveDetail(row.u_idx, row.uu_idx)">상세</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins"

export default {
  name: "UtilityListPubCurrentLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {
    utilityData: {
      default: () => {
        return [];
      },
    },
    utilTopCategory: {
      default: () => {
        return [];
      },
    },
    utilBottomCategory: {
      default: () => {
        return [];
      },
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      },
    },
  },
  data() {
    return {};
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    tableIdx(index) {
      return (
        this.paginationData.total -
        index -
        (this.paginationData.page - 1) * this.paginationData.size
      );
    },
    returnState(type, start, end) {
      let now = this.returnDateTime(new Date());

      if (type == 'sell') {
        if (start > now) {
          return '판매대기';
        } else if (start < now && end > now) {
          return '판매중';
        } else if (end < now) {
          return '판매종료';
        }
      } else if (type == 'use') {
        if (start > now) {
          return '사용대기';
        } else if (start < now && end > now) {
          return '사용가능';
        } else if (end < now) {
          return '기한만료';
        }
      }
    },
    moveDetail(idx, uu_idx){
      this.$router.push(`/item/utility/${idx}/detail/${uu_idx}`);
    }
  },
  watch: {},
};
</script>

<style scoped></style>
